import React from "react";
import 'react-multi-carousel/lib/styles.css';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { fetchFilters, filtersDashboard, getA2DFilters, getCycle } from '../../actions/dashboardAction';
import { withTheme } from '../../themes/theming';
import './index.css';
import Select from "react-select";
import $ from 'jquery';
import * as AppConst from '../../AppConstant';
import DatePicker from "react-datepicker";
import moment from "moment";
import DateRangeSlider from "./dateRangeSlider";
import { toastr } from "react-redux-toastr";
import { fetchToolboxByType } from "../../actions/leftNavAction";
var I18n = require("react-redux-i18n").I18n;

// Simple auto-selection configuration - easily extensible
const AUTO_SELECTIONS = {
    "TSM/LSM": ["Mechanical workshop"],
    "Body & Paint": ["BodyShop", "PaintShop"],
    "Network Assessment":  ["Mechanical workshop"],
};

class SearchFilter extends React.Component {
    /* eslint-disable */
    constructor(props) {
        super(props);
        this.state = {
            nmscList: [],
            brandList: [],
            countryList: [],
            regionList: [],
            selectedNmsc: [],
            selectedBrand: [],
            selectedCountry:[],
            userMdl: {},
            // activityDto: {
            //     nmscList: null,
            //     loggedInUser: this.props.user.userMdl.username,
            //     brand: null,
            //     country: null,
            //     region: null
            // },
            filterData: {},
            defaultAllObj: [{ "value": "All", "label": I18n.t('standardMessages.selectAll') },{ "value": "None", "label": I18n.t('standardMessages.unSelectAll') }],
            activityToolBox: [], // for NAS - assessment tile
            calenderSliderStartDate: null,
            calenderSliderEndDate: null,
            selectedCycle:  [], // variable to store the default cycle value
            cycleStartDate: null,
            cycleEndDate:null,
            cycleData: [], // Variable to store the cycle data,
            isStartDateChanged: false,
            isEndDateChanged: false,
            restrictedStartDate: null, // this is for min start date select with respect to cycle selection
            restrictedEndDate: null, // this is for min end date select with respect to cycle selection
            initialStartDateForSlicer: null,
            initialEndDateForSlicer: null,
            useCalenderStartDate: false,
            useCalenderEndDate: false,
            selecteda2dDealerDetails: [],
            a2dOptions: []  
        };
    }

    // Helper method to parse date strings to UTC Date objects to avoid timezone issues
    parseToUTCDate = (dateString) => {
        if (!dateString) return null;
        
        try {
            // Handle different date string formats
            let date;
            if (typeof dateString === 'string') {
                // If it's already in YYYY-MM-DD format
                if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
                    const [year, month, day] = dateString.split('-').map(Number);
                    date = new Date(Date.UTC(year, month - 1, day));
                } else {
                    // For other formats, parse normally but convert to UTC
                    date = new Date(dateString);
                    date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
                }
            } else {
                // If it's already a Date object
                date = new Date(Date.UTC(dateString.getFullYear(), dateString.getMonth(), dateString.getDate()));
            }
            
            console.log(`UTC Conversion: ${dateString} -> ${date.toISOString()}`);
            return date;
        } catch (error) {
            console.error('Error parsing date to UTC:', error, dateString);
            return new Date(); // Fallback to current date
        }
    }

    componentWillMount() {

        let activityDto = {}
        if (this.props.userMdl.activeProgram === 'TSM') {
            activityDto = { ...this.props.TsmActivityDto }
        }
        if (this.props.userMdl.activeProgram === 'TSM_BNP') {
            activityDto = { ...this.props.BnpActivityDto }
        }
        if (this.props.userMdl.activeProgram === 'TSM_USED_CAR') {
            activityDto = { ...this.props.UsedcarActivityDto }
        }
        if (this.props.userMdl.activeProgram === 'TSM_SURVEYS') {
            activityDto = { ...this.props.tmeSurveysActivityDto }
        }
         if (this.props.userMdl.activeProgram === 'NAS') {
           activityDto = { ...this.props.nasActivityDto }
        }
        activityDto["loggedInUser"] = this.props.user.userMdl.username;
        activityDto["businessArea"] = this.props.user.userMdl.businessAreaKey;
        this.props.dispatch(fetchFilters(activityDto, this.props.userMdl.activeProgram));
        this.setState({ activityDto: activityDto })


    }
    componentDidMount() {
        let filterProps = null

        if (this.props.userMdl.activeProgram === 'TSM') {
            filterProps = this.props.Tsmfilters
        }
        if (this.props.userMdl.activeProgram === 'TSM_BNP') {
            filterProps = this.props.Bnpfilters

        }
        if (this.props.userMdl.activeProgram === 'TSM_USED_CAR') {
            filterProps = this.props.Usedcarfilters
        }
        if (this.props.userMdl.activeProgram === 'TSM_SURVEYS') {
            filterProps = this.props.tmeSurveysfilters
        }
        if (this.props.userMdl.activeProgram === 'NAS') {
            filterProps = this.props.nasFilters
        }

        if (filterProps) {
            if (filterProps.selectedNmsc && filterProps.selectedNmsc.length > 0) {
                this.setSelectedValue("nmscCodeList", "selectedNmsc", filterProps.selectedNmsc, false);
            }

            if (filterProps.selectedA2DDealerDetails && filterProps.selectedA2DDealerDetails.length > 0) {
                this.setSelectedValue("a2dDealerList", "selecteda2dDealerDetails", filterProps.selectedA2DDealerDetails, false);
            }

            if (filterProps.selectedBrand && filterProps.selectedBrand.length > 0) {
                this.setSelectedValue("brandList", "selectedBrand", filterProps.selectedBrand, false);
            }
            if (filterProps.selectedCountry && filterProps.selectedCountry.length > 0) {
                this.setSelectedValue("countryList", "selectedCountry", filterProps.selectedCountry, false);
            }
            if (filterProps.selectedRegion && filterProps.selectedRegion.length > 0) {
                this.setSelectedValue("regionList", "selectedRegion", filterProps.selectedRegion, false);
            } 
            /** For NAS - assesment tile sending payload and this is used to prevent resetting of filters*/
            if(this.props.userMdl.activeProgram === AppConst.activeProgramNas){
                /** Payload for toolBox */
                if (filterProps.activityToolBox && filterProps.activityToolBox.length > 0) {
                    this.setSelectedValue("toolboxIDList", "selectedToolbox", filterProps.activityToolBox, false);
                }

                /** Payload for start date */
                if (filterProps.startDate) {
                    // Use UTC conversion to avoid timezone issues across countries
                    const startDateUTC = this.parseToUTCDate(filterProps.startDate);
                    this.setState({ calenderSliderStartDate: startDateUTC, cycleStartDate: startDateUTC });
                } 
                
                /** Payload for end date */
                if (filterProps.endDate) {
                    // Use UTC conversion to avoid timezone issues across countries
                    const endDateUTC = this.parseToUTCDate(filterProps.endDate);
                    this.setState({ calenderSliderEndDate: endDateUTC, cycleEndDate: endDateUTC });
                } 

                /** Cycle*/
                if (filterProps.Cycle) {
                    this.setState({ selectedCycle: filterProps.Cycle });
                } 
            }
        }

        /** Fetching the a2d filter options */
         this.props.dispatch(getA2DFilters(this.onSuccessA2Ddata, this.onFailureA2Ddata))

         if (this.props.userMdl?.activeProgram === AppConst.activeProgramNas) {
            this.props.dispatch(getCycle(this.onSucessCycleData, this.onFailureCycleData)); // Fetch cycle Data
            /** Fetch the toolboxs available */
            let ceaYear = new Date();
            ceaYear = this.props.user.userMdl.ceaDefaultYears ? this.props.user.userMdl.ceaDefaultYears.value : ceaYear.getfullYear();
            this.props.dispatch(fetchToolboxByType(this.props.user.userMdl.activeProgramID, this.props.user.userMdl.flagCEA, (this.props.user.userMdl.businessAreaKey === AppConst.businessAreaKeyPer), ceaYear, this.props.user.userMdl.getNetworkUserPrimaryKey));
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // Check if toolboxByType data has been updated in Redux
        if (
            prevProps.toolboxByType !== this.props.toolboxByType &&
            this.props.toolboxByType?.toolboxByType &&
            this.props.toolboxByType.toolboxByType.length > 0 &&
            !this.state.selectedToolbox
        ) {
            // Find "CS Quality Audit" or default to the first item
            const csQualityAssessment = this.props.toolboxByType.toolboxByType.find(
                // item => item.toolboxName === "CS Quality Assessment"
                item => item.toolboxName === "CS Quality Assessment" || item.toolboxName === "CS Quality Audit"
            );
            const defaultToolbox = csQualityAssessment || this.props.toolboxByType.toolboxByType[0];

            // Set the default selected toolbox to "CS Quality Assessment"
            this.setState({
                selectedToolbox: [
                    {
                        value: defaultToolbox?.packageMapPrimaryKey,
                        label: defaultToolbox?.toolboxName,
                    },
                ],
    		}, () => {
    // Only once when data is ready
    if (this.props.cycleDataList && this.props.cycleDataList.length > 0 && !this.state.filterData?.activityToolBox) {
        this.refresh();
    }
        });
        }

        /** This is used for initial cycle date - start date and end date */
        if (this.state.selectedCycle && this.state.selectedCycle.length > 0 && prevState.selectedCycle !== this.state.selectedCycle) {
            const [startDateStr, endDateStr] = this.state.selectedCycle[0]?.value?.split(" to ") || [];
            
            if (startDateStr && endDateStr) {
                 this.setState({
                    restrictedStartDate: this.parseToUTCDate(startDateStr),
                    restrictedEndDate: this.parseToUTCDate(endDateStr),
                });
    
                this.setState({
                    initialStartDateForSlicer: this.parseToUTCDate(startDateStr),
                    initialEndDateForSlicer: this.parseToUTCDate(endDateStr),
                })
            } 
        } 
        /* to prevent the reset for cycle */ 
        if ( prevProps.cycleData !== this.props.cycleData &&
            this.props.cycleData?.length > 0 &&
            !this.state.selectedCycle && 
            this.state.cycleData && this.state.cycleData?.length > 0) {
            
            /** user selected filter for cycle */
            const lastIndex = this.state.cycleData?.length - 1;
            this.setState({
                selectedCycle: [{
                    value: this.state.cycleData[lastIndex]?.value,
                    label: this.state.cycleData[lastIndex]?.label,
                }],
            });

            /** Set the user selected start date and end date while filtering */
            if (this.state.cycleData && this.state.cycleData?.length > 0) {    
                if(this.state.calenderSliderStartDate && this.state.calenderSliderEndDate ){
                   const startDt = moment(this.state.calenderSliderStartDate).format('YYYY-MM-DD');
                   const endDt = moment(this.state.calenderSliderEndDate).format('YYYY-MM-DD');
    
                this.setState({
                    cycleStartDate: this.parseToUTCDate(startDt),
                    cycleEndDate: this.parseToUTCDate(endDt),
                });
            }
        }
        }
    }

    /** Function to handle the success response of A2D filter data options */
    onSuccessA2Ddata = (response) =>{
        if(!response?.length) return;
        const defaultOptions = [
            { "value": "All", "label": I18n.t('standardMessages.selectAll') },
            { "value": "None", "label": I18n.t('standardMessages.unSelectAll') }
        ];
        this.setState({a2dOptions: [...defaultOptions, ...response]})
        
        // Dynamic auto-selection - handles arrays of any length (1, 2, or more terms)
        const programName = this.props.userMdl?.activeProgramName;
        const searchTerms = AUTO_SELECTIONS[programName];
        const hasUnselectAll = this.state.selecteda2dDealerDetails.some(item => item.value === "None" || (item.label && item.label.toLowerCase().includes("unselect all")));

        if(!hasUnselectAll){
            if (searchTerms && Array.isArray(searchTerms) && searchTerms?.length > 0) {
                const selectedOptions = response.filter(item => item?.value && searchTerms.some(term => item?.value.toLowerCase().includes(term.toLowerCase())));      
                if (selectedOptions.length > 0) this.setState({ selecteda2dDealerDetails: selectedOptions });
            }
        }
    }

    onFailureA2Ddata = (error) =>{
        console.log("🚀 ~ SearchFilter ~ error:", error)
    }

    // Function to handle the success response of cycle data
    onSucessCycleData = (response) => {
        const transformedData = response?.map(item => ({
            value: item?.cycle,
            label: item?.name
                .toLowerCase() // Convert to lowercase
                .replace(/_/g, ' ') // Replace underscores with spaces
                .replace(/\b\w/g, char => char?.toUpperCase()), // Capitalize the first letter of each word
        }));
        
        // Extract first cycle's start date
        const firstCycleStartDate = transformedData[0]?.value?.split(" to ")[0];
        // Extract second cycle's end date
        const secondCycleEndDate = transformedData[1]?.value?.split(" to ")[1];
        // Add "Select All" option to the cycleData
        const cycleDataWithSelectAll = [
            { value: `${firstCycleStartDate} to ${secondCycleEndDate}`, label: "Select All" },
            ...transformedData,
        ];
        
        this.setState({ cycleData: cycleDataWithSelectAll });

      // Set the default value for cycle to the last item
      if (!this.props.nasFilters?.Cycle?.length && this.state.cycleData && this.state.cycleData?.length > 0) {
            const lastIndex = this.state.cycleData?.length - 1;
            this.setState({
                selectedCycle: [{
                    value: this.state.cycleData[lastIndex]?.value,
                    label: this.state.cycleData[lastIndex]?.label,
                }],
            });
        }

        // Set the cycle start and end dates based on the first cycle value
        // Check if cycleData exists and set default values
        if (this.state.cycleData && this.state.cycleData?.length > 0) {
            const lastIndex = this.state.cycleData?.length - 1;
            const defaultCycle = this.state.cycleData[lastIndex]?.value;

            if(this.state.calenderSliderStartDate && this.state.calenderSliderEndDate ){
               const startDt = moment(this.state.calenderSliderStartDate).format('YYYY-MM-DD');
               const endDt = moment(this.state.calenderSliderEndDate).format('YYYY-MM-DD');
            
            this.setState({
                cycleStartDate: this.parseToUTCDate(startDt),
                cycleEndDate: this.parseToUTCDate(endDt),
            });

            }
            else {
                /** To set the intial start date and end date according to cycle */
                    const [startDateStr, endDateStr] = defaultCycle?.split(" to ");
        
                    this.setState({
                        cycleStartDate: this.parseToUTCDate(startDateStr),
                        cycleEndDate: this.parseToUTCDate(endDateStr),
                    });

                    this.setState({
                        restrictedStartDate: this.parseToUTCDate(startDateStr),
                        restrictedEndDate: this.parseToUTCDate(endDateStr),
                    });

                    this.setState({
                        initialStartDateForSlicer: this.parseToUTCDate(startDateStr),
                        initialEndDateForSlicer: this.parseToUTCDate(endDateStr),
                    })
                    
                } 
        }
    }

    onFailureCycleData = (error) => {
        console.log("🚀 ~ SearchFilter ~ error:", error)
    }

    componentWillUnmount() {

    }

    getSelectedList(selectedList) {
        let filteredList = [];
        if (selectedList !== undefined) {
            selectedList.map(value => {
                let obj = {
                    label: I18n.t("status." + value.toLowerCase()),
                    value: value,
                    selected: 'selected'
                };
                filteredList.push(obj);
            });
        }
        return filteredList;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.flag) {
            $("#searchId").show();
            $("#hrId").hide();
        } else {
            $("#searchId").hide();
            $("#hrId").show();
        }

        let roles = [];

        roles = nextProps.user.userMdl.roles;
        if (nextProps.user.userMdl.roles && nextProps.user.userMdl.activeProgram !== this.state.userMdl.activeProgram) {
            for (var i = 0; i < roles.length; i++) {
                if (roles[i].toUpperCase() === "KET NMSC ADMIN" || roles[i].toUpperCase() === "KET NMSC USER" || roles[i].toUpperCase() === "KET NMSC EXTERNAL" || roles[i].toUpperCase() === "KET NMSC FIELD") {
                    this.setState({ nmscFlag: true });
                    break;
                }
            }
            this.setState({ userMdl: nextProps.user.userMdl });
        }


        if (nextProps.filters.nmscCode && (nextProps.filters.nmscCode.length !== this.state.nmscList.length
            || nextProps.filters.l1.length !== this.state.brandList.length
            || nextProps.filters.l2.length !== this.state.countryList.length
            || nextProps.filters.l3.length !== this.state.regionList.length)) {
            this.setState({
                nmscList:  this.props.nmscFlag ? nextProps.filters.nmscCode : this.state.defaultAllObj.concat(nextProps.filters.nmscCode),
                brandList:  nextProps.filters.l1,
                countryList: this.state.defaultAllObj.concat( nextProps.filters.l2),
                regionList: nextProps.filters.l3
            });

        }

        /** FOr toolbox dropdown list in NAS section*/
        if (nextProps.toolboxByType.toolboxByType) {
            const options =[]
             nextProps.toolboxByType.toolboxByType.map((d) => {
               options.push({ value: d.packageMapPrimaryKey,
                label: d.toolboxName } ) 
                return null;          
            });
            // Set Values for selectedToolbox.
            if (this.state.selectedToolbox?.length > 0) {
                let modifiedList = [];
                for (var j = 0; j < this.state.selectedToolbox?.length; j++) {
                    let value = this.state.selectedToolbox[j].value;
                    // let label = this.state.selectedToolbox[j].label;
                    let obj = options.filter(option => option.value === value);
                    if (obj.length > 0) {
                        let selectedObj = {
                            label: obj[0]?.label,
                            value: obj[0]?.value,
                            selected: 'selected'
                        };
                        modifiedList.push(selectedObj);
                    }
                }
                this.setState({ selectedToolbox: modifiedList });
            }
            this.setState({ activityToolBox: options });
        }

        /** Add persistence logic for a2d dealer details dropdown similar to selectedToolbox */
            // Set Values for selecteda2dDealerDetails to maintain state persistence
            if (this.state.selecteda2dDealerDetails?.length > 0) {
                let modifiedA2DList = [];
                for (var k = 0; k < this.state.selecteda2dDealerDetails?.length; k++) {
                    let value = this.state.selecteda2dDealerDetails[k].value;
                    // Check if this value still exists in the available options
                    let obj = this.state.a2dOptions?.filter(option => option.value === value);
                    if (obj && obj.length > 0) {
                        let selectedObj = {
                            label: obj[0]?.label,
                            value: obj[0]?.value,
                            selected: 'selected'
                        };
                        modifiedA2DList.push(selectedObj);
                    }
                }
                if (modifiedA2DList.length > 0) {
                    this.setState({ selecteda2dDealerDetails: modifiedA2DList });
                }
            }
    }

    setSelectedValue(key1, key2, list, isReloadReq) {
        var valueOptions = [];
        list.map(function (item) {
            valueOptions.push(item.value);
        });
        let activityDto = { ...this.state.activityDto };
        activityDto[key1] = valueOptions;
        // console.log(activityDto)

        this.setState({ activityDto, [key2]: list });

        if (isReloadReq) {
            this.reloadDropDowns(activityDto);
        }

    }

    onNmscChange = (selectedOption,event) => {
        var valueOptions = [];
        if(event.action === "select-option" && event.option.value === "All"){  
            this.setState({ selectedNmsc: this.state.nmscList})  
        }else if(event.action === "select-option" && event.option.value === "None"){
            this.setState({ selectedNmsc: [] })
        }else if(event.action === "deselect-option" && (event.option.value === "None" || event.option.value === "All")){
            this.setState({ selectedNmsc: [] })
        }else if(event.action === "deselect-option") {            
            selectedOption.map(function (item) {
                if(item.value !== "All" && item.value !== "None"){
                    valueOptions.push(item.value);
                }
            })
            if (selectedOption.length === 1 && selectedOption[0].value === "None") {
                this.setState({ selectedNmsc: [] })
            }else{
                this.setState({  selectedNmsc: selectedOption.filter(o => o.value !== "All") })
            }
        }
        else if (selectedOption.length === this.state.nmscList.length - 1) {
            this.setState({ selectedNmsc : this.state.nmscList}) 
        }
        else{
            var selectedOpt = [];
            selectedOption.map(function (item) {
                if(item.value !== "All" && item.value !== "None"){
                    valueOptions.push(item.value);
                    selectedOpt.push(item);
                }        
            })      
            selectedOpt.push({ "value": "None", "label": I18n.t('standardMessages.unSelectAll') });    
            this.setState({ selectedNmsc: selectedOpt})            
        }  
        const activityDto = { ...this.state.activityDto };
        activityDto["nmscCodeList"] = valueOptions;
        this.setState({ activityDto });
        if(event.action === "select-option" && event.option.value === "None"){}else{
            this.reloadDropDowns(activityDto);
        }        
        // this.setSelectedValue("nmscList", "selectedNmsc", selectedOption, true);
    }

    onBrandChange = (selectedOption) => {
        this.setSelectedValue("brandList", "selectedBrand", selectedOption, true);
    }

    onCountryChange = (selectedOption,event) => {
        var valueOptions = [];
        if(event.action === "select-option" && event.option.value === "All"){  
            this.setState({ selectedCountry: this.state.countryList})  
        }else if(event.action === "select-option" && event.option.value === "None"){
            this.setState({ selectedCountry: [] })
        }else if(event.action === "deselect-option" && (event.option.value === "None" || event.option.value === "All")){
            this.setState({ selectedCountry: [] })
        }else if(event.action === "deselect-option") {            
            selectedOption.map(function (item) {
                if(item.value !== "All" && item.value !== "None"){
                    valueOptions.push(item.value);
                }
            })
            if (selectedOption.length === 1 && selectedOption[0].value === "None") {
                this.setState({ selectedCountry: [] })
            }else{
                this.setState({  selectedCountry: selectedOption.filter(o => o.value !== "All") })
            }
        }
        else if (selectedOption.length === this.state.countryList.length - 1) {
            this.setState({ selectedCountry : this.state.countryList}) 
        }
        else{
            var selectedOpt = [];
            selectedOption.map(function (item) {
                if(item.value !== "All" && item.value !== "None"){
                    valueOptions.push(item.value);
                    selectedOpt.push(item);
                }
            })      
            selectedOpt.push({ "value": "None", "label": I18n.t('standardMessages.unSelectAll') });    
            this.setState({ selectedCountry: selectedOpt})           
        } 
        const activityDto = { ...this.state.activityDto };
        activityDto["countryList"] = valueOptions;
        this.setState({ activityDto });
        if(event.action === "select-option" && event.option.value === "None"){}else{
            this.reloadDropDowns(activityDto);
        }
    }

    onCycleChange = (selectedOption) => {
        this.setSelectedValue("CycleList", "selectedCycle", selectedOption.slice(-1), true);
        const lastOption = selectedOption.slice(-1)[0];
        if (!lastOption?.value) return;

        /** For select All option */
        if(lastOption?.label === "Select All") {
            this.setState({ selectedCycle: this.state.cycleData}) 
        }
      
        const [startDateStr, endDateStr] = lastOption.value.split(" to ");
      
        this.setState({
          cycleStartDate: this.parseToUTCDate(startDateStr),
          cycleEndDate: this.parseToUTCDate(endDateStr),
        });

        this.setState({
            initialStartDateForSlicer: this.parseToUTCDate(startDateStr),
            initialEndDateForSlicer: this.parseToUTCDate(endDateStr),
          });

        this.setState({ calenderSliderStartDate: this.parseToUTCDate(startDateStr) });
        this.setState({ calenderSliderEndDate: this.parseToUTCDate(endDateStr) });

        this.setState({
            restrictedStartDate: this.parseToUTCDate(startDateStr),
            restrictedEndDate: this.parseToUTCDate(endDateStr),
        });
        this.setState({isStartDateChanged: false, isEndDateChanged: false}) 
        this.setState({useCalenderStartDate: false, useCalenderEndDate: false}) // we can slide the date slider as well as coose the date

    }

    /** Callback function to handle the calender slicer start date */
    calenderStartDate = (newDate) => {
        const { calenderSliderStartDate } = this.state;
        if (!calenderSliderStartDate || calenderSliderStartDate.getTime() !== newDate.getTime()) {
          this.setState({ calenderSliderStartDate: newDate });
          this.setState({isStartDateChanged: false}) // we can slide the date slider as well as coose the date 
          this.setState({useCalenderStartDate: true}) 
        }
      };
      
    /** Callback function to handle the calender slicer end date */
      calenderEndDate = (newDate) => {
        const { calenderSliderEndDate } = this.state;
        if (!calenderSliderEndDate || calenderSliderEndDate.getTime() !== newDate.getTime()) {
          this.setState({ calenderSliderEndDate: newDate });
          this.setState({isEndDateChanged: false})// we can slide the date slider as well as coose the date 
          this.setState({useCalenderEndDate: true})
        }
      };
      
    /** Handle ToolBox function for NAS*/
    onToolBoxChange = (selectedOption,event) => {
        this.setSelectedValue("toolboxIDList", "selectedToolbox", selectedOption.slice(-1), true);
    }

    /** Handle Date change for NAS*/
    onDateChange = (ev, action) => {
        if (ev) {
            var dt = moment(ev);
            const activityDto = { ...this.state.activityDto };
            activityDto[action] = dt.format("YYYY-MM-DD");
            this.setState({ activityDto });

            const startDate = moment(activityDto.startDate, "YYYY-MM-DD");
            const endDate = moment(activityDto.endDate, "YYYY-MM-DD");
            
            const cycleStart = moment(this.state.cycleStartDate, "YYYY-MM-DD");``
            const cycleEnd = moment(this.state.cycleEndDate, "YYYY-MM-DD");
            const sliderStart = moment(this.state.calenderSliderStartDate, "YYYY-MM-DD");
            const sliderEnd = moment(this.state.calenderSliderEndDate, "YYYY-MM-DD");
            
            //const startDateValidations = startDate.clone().startOf('day').isAfter(endDate.clone().startOf('day')) || sliderStart.clone().startOf('day').isAfter(endDate.clone().startOf('day')) || sliderStart.clone().startOf('day').isAfter(cycleEnd.clone().startOf('day'))
            // const endDateValidations = endDate.clone().startOf('day').isBefore(sliderStart.clone().startOf('day')) || sliderEnd.clone().startOf('day').isBefore(sliderStart.clone().startOf('day')) ||endDate.clone().startOf('day').isBefore(startDate.clone().startOf('day')) || sliderEnd.clone().startOf('day').isBefore(cycleStart.clone().startOf('day'))
            
            // if (action === "startDate" &&(startDateValidations)) {
            //     this.setState((prevState) => ({
            //         activityDto: {
            //             ...prevState.activityDto,
            //             startDate: this.state.initialStartDateForSlicer,
            //         },
            //     }));
            //     return toastr.error("Start date cannot be later than end date.");
            // }

            // if (action === "endDate" &&(endDateValidations)) {
            //     this.setState((prevState) => ({
            //         activityDto: {
            //             ...prevState.activityDto,
            //             endDate: this.state.initialEndDateForSlicer,
            //         },
            //     }));
            //     return toastr.error("End date cannot be earlier than start date.");
            // }
            
            if(action == "startDate") {
                this.setState({
                    isStartDateChanged: true,
                    cycleStartDate: new Date(activityDto?.startDate),
                    useCalenderStartDate: false,
                });
                // this.setState({isStartDateChanged: true}); // we can slide the date slider as well as coose the date 
                // this.setState({cycleStartDate: new Date(activityDto?.startDate) });
                // this.setState({useCalenderStartDate: false}) 
            }
            if(action == "endDate") {
                this.setState({
                    isEndDateChanged: true,
                    cycleEndDate: new Date(activityDto.endDate),
                    useCalenderEndDate: false,
                });
                // this.setState({isEndDateChanged: true}); // we can slide the date slider as well as coose the date 
                // this.setState({cycleEndDate: new Date(activityDto?.endDate) });
                // this.setState({useCalenderEndDate: false})
            }
            this.reloadDropDowns(activityDto);
        } else {
            const activityDto = { ...this.state.activityDto };
            activityDto[action] = "";
            this.setState({ activityDto });
            this.reloadDropDowns(activityDto);
        }

    }

    onRegionChange = (selectedOption) => {
        this.setSelectedValue("regionList", "selectedRegion", selectedOption, true);
    }

    reloadDropDowns = (activityDto) => {
        // console.log(activityDto)
        this.props.dispatch(fetchFilters(activityDto, this.props.userMdl.activeProgram));

        //this.setState({activityDto:activityDto})

    }

    refresh = (e) => {
        // console.log(e)
        // e.preventDefault();
        let activeProgram = this.props.userMdl.activeProgram;
          /** initial start date and end date */
          let initialStartDate, initialEndDate;
          if(activeProgram === "NAS"){
              const initialCycle = this.props?.cycleDataList[this.props?.cycleDataList?.length - 1];
              [initialStartDate, initialEndDate] = initialCycle.cycle.split(" to ");
        }

        let filterData = {
            selectedNmsc: this.state.selectedNmsc,
            selectedBrand: this.state.selectedBrand,
            selectedCountry: this.state.selectedCountry,
            selectedRegion: this.state.selectedRegion,
            activityToolBox: this.state.selectedToolbox,
            selectedA2DDealerDetails: this.state.selecteda2dDealerDetails
        };
        if (activeProgram === "NAS" && this.state.selectedToolbox == undefined ) {
            toastr.error("Please select toolbox");
            return
        }
        if(activeProgram === AppConst.activeProgramNas) filterData["activityToolBox"] = this.state.selectedToolbox;
        if (activeProgram === AppConst.activeProgramNas) {
            filterData["startDate"] = this.state.isStartDateChanged
            ? this.state.activityDto.startDate
            : this.state.calenderSliderStartDate 
                ? new Date(this.state.calenderSliderStartDate).toISOString().split('T')[0] 
                : this.state.cycleStartDate 
                    ? new Date(this.state.cycleStartDate).toISOString().split('T')[0] 
                    : this.state.activityDto.startDate 
                        ? this.state.activityDto.startDate 
                        : initialStartDate;
        
        }
        if(activeProgram === AppConst.activeProgramNas) {
            filterData["endDate"] = this.state.isEndDateChanged
            ? this.state.activityDto.endDate
            : this.state.calenderSliderEndDate 
                ? new Date(this.state.calenderSliderEndDate).toISOString().split('T')[0] 
                : this.state.cycleEndDate 
                    ? new Date(this.state.cycleEndDate).toISOString().split('T')[0] 
                    : this.state.activityDto.endDate 
                        ? this.state.activityDto.endDate 
                        : initialEndDate;
               
        }
        if(activeProgram === AppConst.activeProgramNas) filterData["Cycle"] = this.state.selectedCycle
        this.setState({ filterData: filterData })
        this.props.history.push('/redirect', { 'filterData': filterData });
        // console.log(this.state.activityDto)
        this.props.dispatch(filtersDashboard(filterData, activeProgram, this.state.activityDto))


    }

    // This functions handles the start date within the selected cycle
    handleStartDateCycleValidation = (e) => {
        const inputDate = moment(e.target.value, "DD/MM/YYYY", true); // Parse the input date
        const minAllowedDate = moment(this.state.initialStartDateForSlicer, "DD/MM/YYYY"); // Minimum allowed date
        const maxAllowedDate = this.state.isStartDateChanged ? (this.state.calenderSliderEndDate ? moment(this.state.calenderSliderEndDate, "DD/MM/YYYY") : moment(this.state.initialEndDateForSlicer, "DD/MM/YYYY")) : moment(this.state.initialEndDateForSlicer, "DD/MM/YYYY");
        
        /** This code is for validation for start date */
        if (inputDate.isValid() && inputDate.isAfter(maxAllowedDate, 'day') && !inputDate.isBefore(minAllowedDate, 'day')) {
            e.preventDefault(); // Prevent invalid input
             toastr.error(`Start date cannot be later than end date.`);
             this.setState((prevState) => ({
              activityDto: {
                  ...prevState.activityDto,
                  startDate: this.state.initialStartDateForSlicer,
              },
          }));
              this.setState({
                  cycleStartDate: this.state.initialStartDateForSlicer,
              });
              return;
          }

      
        if (inputDate.isValid() && inputDate.isBefore(minAllowedDate, 'day')) {
          e.preventDefault(); // Prevent invalid input
           toastr.error(`You cannot select a date before ${moment(this.state.initialStartDateForSlicer).format("DD/MM/YYYY")}`);
           this.setState((prevState) => ({
            activityDto: {
                ...prevState.activityDto,
                startDate: this.state.initialStartDateForSlicer,
            },
        }));
            this.setState({
                initialStartDateForSlicer: this.state.initialStartDateForSlicer,
            });
            return;
        }
      };

       // This functions handles the end date within the selected cycle
      handleEndDateCycleValidation = (e) => {
        const inputDate = moment(e.target.value, "DD/MM/YYYY", true); // Parse the input date
        const minAllowedDate =this.state.isEndDateChanged ? (this.state.calenderSliderStartDate ? moment(this.state.calenderSliderStartDate, "DD/MM/YYYY") : moment(this.state.initialStartDateForSlicer, "DD/MM/YYYY")): moment(this.state.initialStartDateForSlicer, "DD/MM/YYYY");
        const maxAllowedDate = moment(this.state.initialEndDateForSlicer, "DD/MM/YYYY"); // Maximum allowed date
        
        /** This code is for validation for start date */
        if (inputDate.isValid() && (inputDate.isBefore(minAllowedDate, 'day'))) {
            e.preventDefault(); // Prevent invalid input
             toastr.error(`End date cannot be earlier than start date.`);
             this.setState((prevState) => ({
              activityDto: {
                  ...prevState.activityDto,
                  endDate: this.state.initialEndDateForSlicer,
              },
          }));
              this.setState({
                  cycleEndDate: this.state.initialEndDateForSlicer,
              });
              return;
        }

        if (inputDate.isValid() && inputDate.isAfter(maxAllowedDate, 'day')) {
          e.preventDefault(); // Prevent invalid input
           toastr.error(`You cannot select a date after ${moment(this.state.initialEndDateForSlicer).format("DD/MM/YYYY")}`);
           this.setState((prevState) => ({
            activityDto: {
                ...prevState.activityDto,
                endDate: this.state.initialEndDateForSlicer,
            },
        }));
            this.setState({
                initialEndDateForSlicer: this.state.initialEndDateForSlicer,
            });
            return;
        }
      };

    a2dScanChange = (selectedOption, event) => {
        var valueOptions = [];
        if(event.action === "select-option" && event.option.value === "All"){  
            this.setState({ selecteda2dDealerDetails: this.state.a2dOptions})  
        }else if(event.action === "select-option" && event.option.value === "None"){
            this.setState({ selecteda2dDealerDetails: [] })
        }else if(event.action === "deselect-option" && (event.option.value === "None" || event.option.value === "All")){
            this.setState({ selecteda2dDealerDetails: [] })
        }else if(event.action === "deselect-option") {            
            selectedOption.map(function (item) {
                if(item.value !== "All" && item.value !== "None"){
                    valueOptions.push(item.value);
                }
            })
            if (selectedOption.length === 1 && selectedOption[0].value === "None") {
                this.setState({ selecteda2dDealerDetails: [] })
            }else{
                this.setState({  selecteda2dDealerDetails: selectedOption.filter(o => o.value !== "All") })
            }
        }
        else if (selectedOption.length === this.state.a2dOptions.length - 1) {
            this.setState({ selecteda2dDealerDetails : this.state.a2dOptions}) 
        }
        else{
            var selectedOpt = [];
            selectedOption.map(function (item) {
                if(item.value !== "All" && item.value !== "None"){
                    valueOptions.push(item.value);
                    selectedOpt.push(item);
                }        
            })      
            selectedOpt.push({ "value": "None", "label": I18n.t('standardMessages.unSelectAll') });    
            this.setState({ selecteda2dDealerDetails: selectedOpt})            
        }  
        const activityDto = { ...this.state.activityDto };
        activityDto["a2dDealerList"] = valueOptions;
        this.setState({ activityDto });
        if(event.action === "select-option" && event.option.value === "None"){}else{
            this.reloadDropDowns(activityDto);
        }  
    }
      

    render() {   
        console.log(this.state.selectedNmsc,"selecteda2dDealerDetails", this.state.selecteda2dDealerDetails)   
        const { user: { userMdl } } = this.props;
        const isRestrictedRoles = userMdl.roles.includes("KET Dealer Champion") 

        return (
            <div className="col-md-12" style={{ padding: "0px" }}>
                {this.props.nmscFlag ?
                    <div id="searchId" style={{ display: "none", borderColor: this.props.theme.primaryColor }} className="col-md-12 searchDash">
                        <div className="col-md-12 row control-label">
                            {userMdl?.activeProgram !== AppConst.activeProgramNas && <label className={`col-md-${this.props.user?.userMdl?.businessAreaKey === "VALUE_CHAIN" ? 1 : 3} control-label`} style={{ paddingLeft: '0rem', fontWeight: '400' }}></label>}
                            {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t('Table.cycle')}</label>}
                            {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t('Table.startDate')}</label>}
                            {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t('Table.completionDate')}</label>}
                            {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t('Table.toolbox')} <span style={{color:"#e50000"}}>*</span></label>}
                            <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t('Table.nmsc')}</label>
                            <label className="col-md-2 control-label" style={{ paddingLeft: '0.1rem', width: '6%', overflowWrap: 'normal', fontWeight: '400' }}>{I18n.t('Table.franchise')}</label>
                            {userMdl?.activeProgram !== AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0.2rem', fontWeight: '400' }}>{I18n.t('Table.country')}</label>}
                            {userMdl?.activeProgram !== AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0.1rem', fontWeight: '400' }}>{I18n.t('dealerCertification.region')}</label>}
                            {this.props.user?.userMdl?.businessAreaKey === "VALUE_CHAIN" && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t("userManagement.a2dDealerDetails")}</label>}
                        </div>
                        <div className="col-md-12 input-group control-label">
                            {userMdl?.activeProgram !== AppConst.activeProgramNas && <div className={`col-md-${this.props.user?.userMdl?.businessAreaKey === "VALUE_CHAIN" ? 1 : 3} noPadding bigDD-` + this.props.theme.name}></div>}
                            {userMdl?.activeProgram === AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                        <ReactMultiSelectCheckboxes
                                            value={this.state.selectedCycle}
                                            isSearchable={true}
                                            options={this.state.cycleData || []}
                                            onChange={this.onCycleChange}
                                            //placeholderButtonLabel={I18n.t('standardMessages.all')}
                                        />
                                </div>}

                            {/* Date slicer for startDate and endDate */}
                                {userMdl?.activeProgram === AppConst.activeProgramNas && <div>{<DateRangeSlider 
                                        calenderStartDate={this.calenderStartDate} 
                                        calenderEndDate={this.calenderEndDate}
                                        cycleStartDate={this.state.cycleStartDate}
                                        cycleEndDate={this.state.cycleEndDate}
                                        initialStartDateForSlicer={this.state.initialStartDateForSlicer}
                                        initialEndDateForSlicer={this.state.initialEndDateForSlicer}
                                        useCalenderStartDate={this.state.useCalenderStartDate}
                                        useCalenderEndDate={this.state.useCalenderEndDate}
                                    />}
                                </div>}

                                {userMdl?.activeProgram === AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                <DatePicker className="form-control"
                                        onChange={(e) => this.onDateChange(e, "startDate")}
                                        placeholderText="Start Date"
                                        dateFormat="dd/MM/yyyy"
                                        onBlur={(e) => this.handleStartDateCycleValidation(e)} // Intercept raw input
                                       // isClearable={true}
                                       // selected={this.state.activityDto?.startDate ? this.state.activityDto?.startDate : this.state.calenderSliderStartDate || this.state.cycleStartDate}
                                        selected={this.state.isStartDateChanged ? this.state.activityDto?.startDate : this.state.calenderSliderStartDate || this.state.cycleStartDate}
                                        id="startDate"
                                        name="startDate"
                                        minDate={new Date(this.state.restrictedStartDate)}
                                        maxDate={this.state.isEndDateChanged ? this.state.activityDto?.endDate : this.state.calenderSliderEndDate || this.state.cycleEndDate || new Date(this.state.restrictedEndDate)}
                                        />
                                </div>}

                                {userMdl?.activeProgram === AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                        <DatePicker className="form-control"
                                        onChange={(e) => this.onDateChange(e, "endDate")}
                                        placeholderText="Completion Date"
                                        dateFormat="dd/MM/yyyy"
                                        onBlur={(e) => this.handleEndDateCycleValidation(e)} // Intercept raw input
                                        //isClearable={true}
                                        //selected={this.state.activityDto?.endDate ? this.state.activityDto?.endDate : this.state.calenderSliderEndDate || this.state.cycleEndDate }
                                        selected={this.state.isEndDateChanged ? this.state.activityDto?.endDate : this.state.calenderSliderEndDate || this.state.cycleEndDate }
                                        id="completionDate"
                                        name="completionDate"
                                        minDate={this.state.isStartDateChanged ? this.state.activityDto?.startDate : this.state.calenderSliderStartDate || this.state.cycleStartDate || new Date(this.state.restrictedStartDate)}
                                        maxDate={new Date(this.state.restrictedEndDate)}
                                        />
                                </div>}

                                {userMdl?.activeProgram === AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                        <ReactMultiSelectCheckboxes
                                             value={this.state.selectedToolbox}
                                             isSearchable={true}
                                             options={this.state.activityToolBox}
                                             onChange={this.onToolBoxChange}
                                            // placeholderButtonLabel={I18n.t('standardMessages.all')}
                                        />
                                </div>}

                            <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>

                                <div className="disabledNmsc"><Select
                                    placeholder={this.props.userMdl.nmsc.toUpperCase()}
                                    isDisabled={true}
                                /> </div>
                            </div>
                            <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                <ReactMultiSelectCheckboxes
                                    value={this.state.selectedBrand}
                                    isSearchable={true}
                                    options={this.state.brandList}
                                    onChange={this.onBrandChange}
                                    placeholderButtonLabel={I18n.t('standardMessages.all')} />
                            </div>
                           {userMdl?.activeProgram !== AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                <ReactMultiSelectCheckboxes
                                    value={this.state.selectedCountry}
                                    options={this.state.countryList}
                                    isSearchable={true}
                                    onChange={this.onCountryChange}
                                    placeholderButtonLabel={I18n.t('standardMessages.all')}
                                />
                            </div>}

                            {userMdl?.activeProgram !== AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                <ReactMultiSelectCheckboxes
                                    value={this.state.selectedRegion}
                                    isSearchable={true}
                                    options={this.state.regionList}
                                    onChange={this.onRegionChange}
                                    placeholderButtonLabel={I18n.t('standardMessages.all')}
                                />
                            </div>}
                            {this.props.user?.userMdl?.businessAreaKey === "VALUE_CHAIN" && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                <ReactMultiSelectCheckboxes
                                    value={this.state.selecteda2dDealerDetails}
                                    options={this.state.a2dOptions}
                                    onChange={this.a2dScanChange}
                                    placeholderButtonLabel={I18n.t('standardMessages.all')}
                                />
                            </div>}
                           {userMdl?.activeProgram !== AppConst.activeProgramNas && <div className="col-md-1" style={{ padding: '5px' }}>
                                <button className={"button-" + this.props.theme.name}
                                    onClick={(e) => this.refresh(e)}>
                                    {I18n.t('dashboard.go')}
                                </button>
                            </div>}
                        </div>
                        <br />
                        {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '1.2rem', fontWeight: '400' }}>{I18n.t('Table.country')}</label>}
                        {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0.9rem', fontWeight: '400' }}>{I18n.t('dealerCertification.region')}</label>}
                        {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t("userManagement.a2dDealerDetails")}</label>}
                        {userMdl?.activeProgram === AppConst.activeProgramNas && <div className="col-md-12 input-group control-label">
                            <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                <ReactMultiSelectCheckboxes
                                    value={this.state.selectedCountry}
                                    options={this.state.countryList}
                                    isSearchable={true}
                                    onChange={this.onCountryChange}
                                    placeholderButtonLabel={I18n.t('standardMessages.all')}
                                />
                            </div>
                            <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                <ReactMultiSelectCheckboxes
                                    value={this.state.selectedRegion}
                                    isSearchable={true}
                                    options={this.state.regionList}
                                    onChange={this.onRegionChange}
                                    placeholderButtonLabel={I18n.t('standardMessages.all')}
                                />
                            </div>
                            <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                <ReactMultiSelectCheckboxes
                                    value={this.state.selecteda2dDealerDetails}
                                    options={this.state.a2dOptions}
                                    onChange={this.a2dScanChange}
                                    placeholderButtonLabel={I18n.t('standardMessages.all')}
                                />
                            </div>
                                <div className="col-md-1" style={{ padding: '5px' }}>
                                    <button className={"button-" + this.props.theme.name}
                                        onClick={(e) => this.refresh(e)}>
                                        {I18n.t('dashboard.go')}
                                    </button>
                                </div>
                            </div>}
                    </div>
                    : <div id="searchId" style={{ display: "none", borderColor: this.props.theme.primaryColor }} className="col-md-12 searchDash">
                        <div>
                            <div className="col-md-12 row control-label">
                                {userMdl?.activeProgram !== AppConst.activeProgramNas && <label className={`col-md-${this.props.user?.userMdl?.businessAreaKey === "VALUE_CHAIN" ? 3 : 5} control-label`} style={{ paddingLeft: '0rem', fontWeight: '400' }}></label>}
                                {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t('Table.cycle')}</label>}
                                {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t('Table.startDate')}</label>}
                                {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t('Table.completionDate')}</label>}
                                {userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t('Table.toolbox')} <span style={{color:"#e50000"}}>*</span></label>}
                                {isRestrictedRoles && <label className="col-md-2 pl-4 control-label" style={{ fontWeight: '400' }}>{I18n.t("userManagement.a2dDealerDetails")}</label>}
                                {!isRestrictedRoles && <label className="col-md-2 control-label" style={{ paddingLeft: '0rem', fontWeight: '400' }}>{I18n.t('Table.nmsc')}</label>}
                                {!isRestrictedRoles && <label className="col-md-2 control-label" style={{ paddingLeft: '0.1rem', width: '6%', overflowWrap: 'normal', fontWeight: '400' }}>{I18n.t('Table.franchise')}</label>}
                                {userMdl?.activeProgram !== AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0.2rem', fontWeight: '400' }}>{I18n.t('Table.country')}</label>}
                                {(this.props.user?.userMdl?.businessAreaKey === "VALUE_CHAIN") && <label className="col-md-2 pl-4 control-label" style={{ fontWeight: '400' }}>{I18n.t("userManagement.a2dDealerDetails")}</label>}
                            </div>

                            <div className="col-md-12 input-group control-label">
                                {userMdl?.activeProgram !== AppConst.activeProgramNas && <div className={`col-md-${this.props.user?.userMdl?.businessAreaKey === "VALUE_CHAIN" ? 3 : 5} noPadding bigDD-` + this.props.theme.name}></div>}
                                
                               {userMdl?.activeProgram === AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                        <ReactMultiSelectCheckboxes
                                            value={this.state.selectedCycle}
                                            isSearchable={true}
                                            options={this.state.cycleData || []}
                                            onChange={this.onCycleChange}
                                            //placeholderButtonLabel={I18n.t('standardMessages.all')}
                                        />
                                </div>}


                                {/* Date slicer for startDate and endDate */}
                                {userMdl?.activeProgram === AppConst.activeProgramNas && <div>{<DateRangeSlider 
                                        calenderStartDate={this.calenderStartDate} 
                                        calenderEndDate={this.calenderEndDate}
                                        cycleStartDate={this.state.cycleStartDate}
                                        cycleEndDate={this.state.cycleEndDate}
                                        initialStartDateForSlicer={this.state.initialStartDateForSlicer}
                                        initialEndDateForSlicer={this.state.initialEndDateForSlicer}
                                        useCalenderStartDate={this.state.useCalenderStartDate}
                                        useCalenderEndDate={this.state.useCalenderEndDate}
                                        leftPosition={this.state.leftPosition}
                                    />}
                                </div>}

                                {userMdl?.activeProgram === AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                <DatePicker className="form-control"
                                        onChange={(e) => this.onDateChange(e, "startDate")}
                                        placeholderText="Start Date"
                                        dateFormat="dd/MM/yyyy"
                                        //isClearable={true}
                                        onBlur={(e) => this.handleStartDateCycleValidation(e)} // Intercept raw input
                                        selected={this.state.isStartDateChanged ? this.state.activityDto?.startDate : this.state.calenderSliderStartDate || this.state.cycleStartDate}
                                        id="startDate"
                                        name="startDate"
                                        minDate={new Date(this.state.restrictedStartDate)}
                                        maxDate={this.state.isEndDateChanged ? this.state.activityDto?.endDate : this.state.calenderSliderEndDate || this.state.cycleEndDate || new Date(this.state.restrictedEndDate)}
                                        />
                                </div>}
                            
                                {userMdl?.activeProgram === AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                        <DatePicker className="form-control"
                                        onChange={(e) => this.onDateChange(e, "endDate")}
                                        placeholderText="Completion Date"
                                        dateFormat="dd/MM/yyyy"
                                        //isClearable={true}
                                        onBlur={(e) => this.handleEndDateCycleValidation(e)} // Intercept raw input
                                        selected={this.state.isEndDateChanged ? this.state.activityDto?.endDate : this.state.calenderSliderEndDate || this.state.cycleEndDate }
                                        id="completionDate"
                                        name="completionDate"
                                        minDate={this.state.isStartDateChanged ? this.state.activityDto?.startDate : this.state.calenderSliderStartDate || this.state.cycleStartDate || new Date(this.state.restrictedStartDate)}
                                        maxDate={new Date(this.state.restrictedEndDate)}
                                        />
                                </div>}



                                {userMdl?.activeProgram === AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                        <ReactMultiSelectCheckboxes
                                             value={this.state.selectedToolbox}
                                             isSearchable={true}
                                             options={this.state.activityToolBox}
                                             onChange={this.onToolBoxChange}
                                            // placeholderButtonLabel={I18n.t('standardMessages.all')}
                                        />
                                </div>}

                            {isRestrictedRoles && userMdl?.activeProgram === AppConst.activeProgramNas && <div className={"col-md-2 pl-4 noPadding bigDD-" + this.props.theme.name}>
                                <ReactMultiSelectCheckboxes
                                    value={this.state.selecteda2dDealerDetails}
                                    options={this.state.a2dOptions}
                                    onChange={this.a2dScanChange}
                                    placeholderButtonLabel={I18n.t('standardMessages.all')}
                                />
                            </div>}


                               {!isRestrictedRoles && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                    <ReactMultiSelectCheckboxes
                                        value={this.state.selectedNmsc}
                                        isSearchable={true}
                                        options={this.state.nmscList}
                                        onChange={this.onNmscChange}
                                        placeholderButtonLabel={I18n.t('standardMessages.all')}
                                    />
                                </div>}
                                {!isRestrictedRoles && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                    <ReactMultiSelectCheckboxes
                                        value={this.state.selectedBrand}
                                        isSearchable={true}
                                        options={this.state.brandList}
                                        onChange={this.onBrandChange}
                                        placeholderButtonLabel={I18n.t('standardMessages.all')} />
                                </div>}
                                {userMdl?.activeProgram !== AppConst.activeProgramNas && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                    {this.state.selectedNmsc.length > 0 ? <ReactMultiSelectCheckboxes
                                        value={this.state.selectedCountry}
                                        isSearchable={true}
                                        options={this.state.countryList}
                                        onChange={this.onCountryChange}
                                        placeholderButtonLabel={I18n.t('standardMessages.all')}
                                    /> : <div className="disabledNmsc"><Select
                                        placeholder={I18n.t('standardMessages.all')}
                                        isDisabled={true}
                                    /> </div>}
                                </div>}
                            {this.props.user?.userMdl?.businessAreaKey === "VALUE_CHAIN" && <div className={"col-md-2 pl-4 noPadding bigDD-" + this.props.theme.name}>
                                <ReactMultiSelectCheckboxes
                                    value={this.state.selecteda2dDealerDetails}
                                    options={this.state.a2dOptions}
                                    onChange={this.a2dScanChange}
                                    placeholderButtonLabel={I18n.t('standardMessages.all')}
                                />
                            </div>}
                                {userMdl?.activeProgram !== AppConst.activeProgramNas && <div className="col-md-1" style={{ padding: '5px' }}>
                                    <button className={"button-" + this.props.theme.name}
                                        onClick={(e) => this.refresh(e)}>
                                        {I18n.t('dashboard.go')}
                                    </button>
                                </div>}
                                {isRestrictedRoles && <div className="col-md-1" style={{ padding: '5px' }}>
                                    <button className={"button-" + this.props.theme.name}
                                        onClick={(e) => this.refresh(e)}>
                                        {I18n.t('dashboard.go')}
                                    </button>
                                </div>}
                            </div>
                            <br />
                            <div className="col-md-12 row control-label">
                            {!isRestrictedRoles && userMdl?.activeProgram === AppConst.activeProgramNas && <label className="col-md-2 control-label" style={{ paddingLeft: '0.2rem', fontWeight: '400' }}>{I18n.t('Table.country')}</label>}
                            {(!isRestrictedRoles && userMdl?.activeProgram === AppConst.activeProgramNas) && <label className="col-md-2 pl-4 control-label" style={{ fontWeight: '400' }}>{I18n.t("userManagement.a2dDealerDetails")}</label>}
                            </div>
                            {userMdl?.activeProgram === AppConst.activeProgramNas && <div className="col-md-12 input-group control-label">
                                {!isRestrictedRoles && <div className={"col-md-2 noPadding bigDD-" + this.props.theme.name}>
                                    {this.state.selectedNmsc.length > 0 ? <ReactMultiSelectCheckboxes
                                        value={this.state.selectedCountry}
                                        isSearchable={true}
                                        options={this.state.countryList}
                                        onChange={this.onCountryChange}
                                        placeholderButtonLabel={I18n.t('standardMessages.all')}
                                    /> : <div className="disabledNmsc"><Select
                                        placeholder={I18n.t('standardMessages.all')}
                                        isDisabled={true}
                                    /> </div>}
                                </div>}

                            {!isRestrictedRoles && userMdl?.activeProgram === AppConst.activeProgramNas && <div className={"col-md-2 pl-4 noPadding bigDD-" + this.props.theme.name}>
                                <ReactMultiSelectCheckboxes
                                    value={this.state.selecteda2dDealerDetails}
                                    options={this.state.a2dOptions}
                                    onChange={this.a2dScanChange}
                                    placeholderButtonLabel={I18n.t('standardMessages.all')}
                                />
                            </div>}
                                
                               {!isRestrictedRoles && <div className="col-md-1" style={{ padding: '5px' }}>
                                    <button className={"button-" + this.props.theme.name}
                                        onClick={(e) => this.refresh(e)}>
                                        {I18n.t('dashboard.go')}
                                    </button>
                                </div>}
                            </div>}
                        </div>
                    </div>}

                <div id="hrId" className="col-md-12 hrClass">
                    <hr style={{ margin: '0px', borderTop: "1px solid" }} />
                </div>
            </div>

        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.loginReducer,
        router: state.routing,

        Tsmfilters: state.dashboardReducer.Tsmfilters,
        Bnpfilters: state.dashboardReducer.Bnpfilters,
        Usedcarfilters: state.dashboardReducer.Usedcarfilters,
        tmeSurveysfilters: state.dashboardReducer.tmeSurveysfilters,
        filters: state.dashboardReducer.filters,
        TsmActivityDto: state.dashboardReducer.TsmActivityDto,
        BnpActivityDto: state.dashboardReducer.BnpActivityDto,
        UsedcarActivityDto: state.dashboardReducer.UsedcarActivityDto,
        tmeSurveysActivityDto: state.dashboardReducer.tmeSurveysActivityDto,
        activityToolBox: state.activityReducer,
        cycleDataList: state.dashboardReducer.cycleDataList,
        toolboxByType: state.leftNavReducer,
        nasFilters: state.dashboardReducer.nasFilters,
        nasActivityDto: state.dashboardReducer.nasActivityDto,
    };
};
export default withRouter(connect(mapStateToProps)(withTheme(SearchFilter)));